module.exports = __webpack_public_path__ + "static/media/collection-bird-11.51f998a6.png";